import React, { FC, memo, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { ScreenContext } from 'react-components'

import {
    Container,
    DestinationContainer,
    InnerContainer,
    StyledCarouselProvider,
    StyledSlider,
    StyledSlide,
} from './styles'
import {
    CMSPopularDestinationTransport,
    PopularDestinationsSectionTransport,
    PopularDestinationTransport,
} from '../../../transports/region-landing-page-transport'
import { Subtitle, Title, TitleContainer } from '../common/styles'
import BestDestinationCard from './destination-card'
import { useResponsiveMobileSlides } from '../hooks'

type Props = {
    popularDestinationsSection: PopularDestinationsSectionTransport
    cmsPopularDestinationsSection: CMSPopularDestinationTransport
}

const BestDestinationsSection: FC<Props> = ({ popularDestinationsSection, cmsPopularDestinationsSection }) => {
    const { heading, subheading, popularDestinations: regions } = popularDestinationsSection
    const { isDesktop, isTablet } = useContext(ScreenContext)

    const popularDestinationSectionHeading = cmsPopularDestinationsSection?.heading ?? heading

    const destinationItems = useMemo(
        () =>
            regions.map((region: PopularDestinationTransport, index) =>
                !isDesktop ? (
                    <StyledSlide key={region.title} index={index}>
                        <BestDestinationCard {...region} />
                    </StyledSlide>
                ) : (
                    <BestDestinationCard key={region.url} {...region} />
                ),
            ),
        [regions, isDesktop],
    )

    const mobileVisibleSlides = useResponsiveMobileSlides({ smallMobile: 2.4, defaultMobile: 2.8 })

    return (
        <Container id="best-destinations">
            <TitleContainer>
                <Title>{popularDestinationSectionHeading}</Title>
                <Subtitle>{subheading}</Subtitle>
            </TitleContainer>
            <InnerContainer>
                {isDesktop ? (
                    <DestinationContainer>{destinationItems}</DestinationContainer>
                ) : (
                    <StyledCarouselProvider
                        totalSlides={destinationItems.length}
                        visibleSlides={isTablet ? 3.8 : mobileVisibleSlides}
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        isIntrinsicHeight
                        lockOnWindowScroll
                        dragStep={1}
                        step={1}
                    >
                        <StyledSlider>{destinationItems}</StyledSlider>
                    </StyledCarouselProvider>
                )}
            </InnerContainer>
        </Container>
    )
}

export default memo(BestDestinationsSection)
